import React from 'react';
import { Card, Spinner, Table } from '../../../core/ui';
import { Navigate } from 'react-router-dom';
import { useTranslation } from '../../../core/context/TranslationContext';
import { useFamily } from '../context/FamilyContext';
import MemberRow from './MemberRow';
import ShareFlagToggle from './ShareFlagToggle';
import styles from './FamilyOverview.module.css';

export default function FamilyOverview() {
  const { t } = useTranslation();
  const { family, loading } = useFamily();

  if (loading) return <Spinner className={styles.m4} />;
  if (!family) return <Navigate to="/family/create" replace />;

  const myUsername = localStorage.getItem('username');
  const me = family.members?.find(m => m.username === myUsername) || family.members?.[0];
  const isOwner = me?.role === 'OWNER';

  return (
    <div className={styles.container}>
      <h4>{family.name}</h4>
      <Card className={styles.mt3}>
        <Card.Body>
          <Card.Title>{t('family.members.title')}</Card.Title>
          <Table className={styles.mt2}>
            <thead>
              <tr>
                <th>{t('username')}</th>
                <th>{t('family.members.role.member')}</th>
                <th>{t('family.share.tooltip')}</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {family.members?.map(m => (
                <MemberRow
                  key={m.userId}
                  member={m}
                  callerIsOwner={isOwner}
                  callerId={me?.userId}
                />
              ))}
            </tbody>
          </Table>
        </Card.Body>
      </Card>
      <Card className={styles.mt3}>
        <Card.Body>
          <Card.Title>{t('family.share.tooltip')}</Card.Title>
          {me && (
            <ShareFlagToggle
              shareReceipts={me.shareReceipts}
              shareBudget={me.shareBudget}
            />
          )}
        </Card.Body>
      </Card>
    </div>
  );
}
